import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { colors } from '../../../../../../colorVars';

function VerticalTicks({ size, bottomPadding, scaleY, numberOfTicks, tickSize, weight }) {
  const ticks = useMemo(() => {
    if (scaleY !== null) {
      return scaleY.ticks(numberOfTicks).map((value) => ({
        value,
        offset: scaleY(value),
      }));
    } else {
      return null;
    }
  }, [scaleY, size, numberOfTicks]);

  return (
    <g stroke={colors.white} strokeWidth={weight}>
      <line x1={size} y1={0} x2={size} y2={size + bottomPadding} />
      {ticks !== null &&
        ticks.map(({ value, offset }) => (
          <line
            x1={size}
            y1={offset}
            x2={size - tickSize}
            y2={offset}
            key={value}
          />
        ))}
    </g>
  );
}

VerticalTicks.propTypes = {
  numberOfTicks: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.number,
  bottomPadding: PropTypes.number,
  tickSize: PropTypes.number,
  weight: PropTypes.number,
};

export default VerticalTicks;
